import React from 'react';
import { Box, Pen, Refresh, Heart } from '@solar-icons/react';
import { useTranslation } from 'react-i18next';

const LegacyVaultHowItWorks: React.FC = () => {
    const { t } = useTranslation();

    const steps = [
        {
            icon: <Box size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.hiw.receive_your_kit'),
            description: t('lv_page.hiw.elegant_keepsake_box_arrives'),
            subDescription: t('lv_page.hiw.includes_usb'),
        },
        {
            icon: <Pen size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.hiw.guided_setup'),
            description: t('lv_page.hiw.90_minute_legacy'),
            subDescription: t('lv_page.hiw.video_tutorials_for_each'),
        },
        {
            icon: <Refresh size={24} color="#2a6355" className='dark:text-primary-light' />,
            title: t('lv_page.hiw.annual_updates'),
            description: t('lv_page.hiw.automated_reminders'),
            subDescription: t('lv_page.hiw.change_tracking_system'),
        },
        {
            icon: <Heart size={24} color="#f38173" className='dark:text-secondary' />,
            title: t('lv_page.hiw.peace_of_mind'),
            description: t('lv_page.hiw.optional_executor_notification_service'),
            subDescription: t('lv_page.hiw.your_family_is_protected'),
        },
    ];

    return (
        <section className="overflow-x-hidden py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] px-4">
                <div className="mx-auto pb-14 text-center lg:w-2/3 lg:pb-24">
                    <h2 className="mb-5 text-[26px]/7 font-bold text-green-700 dark:text-white">{t('lv_page.hiw.title')}</h2>
                    <p className="text-lg md:text-xl">{t('lv_page.hiw.subtitle')}</p>
                </div>

                <div className="grid gap-8 lg:grid-cols-4">
                    {steps.map((step, index) => (
                        <div key={index} className="group relative text-center" data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 200}>
                            <div className="relative mb-6 flex justify-center">
                                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100 text-3xl dark:bg-green-900 z-[1]">{step.icon}</div>
                                {index < steps.length - 1 && <div className="absolute left-1/2 top-10 hidden h-0.5 w-full bg-green-200 lg:block dark:bg-green-800"></div>}
                            </div>

                            <div className="mb-4">
                                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-green-500 text-sm font-bold text-white">{index + 1}</span>
                            </div>

                            <h3 className="mb-3 text-xl font-bold text-green-700 dark:text-white">{step.title}</h3>

                            <p className="mb-2 text-gray-600 dark:text-gray-300">{step.description}</p>

                            <p className="text-sm text-gray-500 dark:text-gray-400">{step.subDescription}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultHowItWorks;
